import type { MonetaryAmountDto } from "./MonetaryAmountDto";

export enum UpdatePurchaseTenderDtoTenderType {
    "PRIVATE" = "PRIVATE",
    "PUBLIC" = "PUBLIC"
}
export enum UpdatePurchaseTenderDtoStatus {
    "DRAFT" = "DRAFT",
    "ACCEPTANCE_PROPOSALS" = "ACCEPTANCE_PROPOSALS",
    "DOCUMENTS_ACCEPTANCE" = "DOCUMENTS_ACCEPTANCE",
    "REVIEW_PROPOSALS" = "REVIEW_PROPOSALS",
    "REBIDDING" = "REBIDDING",
    "COMPLETED" = "COMPLETED"
}
export type UpdatePurchaseTenderDto = {
    /**
     * @type string
    */
    categoryId: string;
    /**
     * @type string
    */
    name: string;
    /**
     * @type string
    */
    description: string;
    /**
     * @type string date-time
    */
    endDateProposals: string;
    /**
     * @type string | undefined date-time
    */
    startProposals?: string;
    /**
     * @type string | undefined date-time
    */
    endDocumentSubmission?: string;
    /**
     * @type string
    */
    storeId: string;
    /**
     * @type string | undefined
    */
    tenderType?: UpdatePurchaseTenderDtoTenderType;
    price?: MonetaryAmountDto;
    /**
     * @type string
    */
    status: UpdatePurchaseTenderDtoStatus;
};
